export class FormatHelper {
    static currencyToFloat(stringVal) {
        return Number(stringVal.replace(/[^0-9.-]+/g, ""));
    }

    static currencyFormat(number, decimals) {
        decimals = decimals == null ? 2 : decimals;
        var formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            // These options are needed to round to whole numbers if that's what you want.
            minimumFractionDigits: decimals, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            maximumFractionDigits: decimals, // (causes 2500.99 to be printed as $2,501)
        });
        return formatter.format(number);
    }

    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    static serialize(obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                // Check if the value is an array
                if (Array.isArray(obj[p])) {
                    // Loop through the array
                    obj[p].forEach((item, index) => {
                        // If the array item is an object, serialize it recursively
                        if (typeof item === 'object' && item !== null) {
                            for (var key in item) {
                                if (item.hasOwnProperty(key)) {
                                    str.push(encodeURIComponent(p) + "[" + index + "][" + key + "]=" + encodeURIComponent(item[key]));
                                }
                            }
                        } else {
                            // If the array item is a simple value, just add it
                            str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(item));
                        }
                    });
                } else {
                    // If the value is not an array, just add it normally
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }
        }
        return str.join("&");
    }    

    static formToArray(form) {
        var field,
            l,
            s = [];
        if (typeof form == "object" && form.nodeName == "FORM") {
            var len = form.elements.length;
            for (var i = 0; i < len; i++) {
                field = form.elements[i];
                if (
                    field.name &&
                    !field.disabled &&
                    field.type != "file" &&
                    field.type != "reset" &&
                    field.type != "submit" &&
                    field.type != "button"
                ) {
                    if (field.type == "select-multiple") {
                        l = form.elements[i].options.length;
                        for (j = 0; j < l; j++) {
                            if (field.options[j].selected)
                                s[s.length] = {
                                    name: field.name,
                                    value: field.options[j].value,
                                };
                        }
                    } else if ((field.type != "checkbox" && field.type != "radio") || field.checked) {
                        s[s.length] = { name: field.name, value: field.value };
                    }
                }
            }
        }
        return s;
    }

    static arrayOfObjectsToKeyValue(array, key, valueKey) {
        var output = {};
        for (var i = 0; i < array.length; i++) {
            output[array[i][key]] = array[i][valueKey];
        }

        return output;
    }

    static ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    /**
     * only working for numbers. Creater for ssn and phone numbers format
     * @param String string [description]
     * @param int num1   [description]
     * @param int num2   [description]
     */
    static addDashes(string, num1, num2) {
        var val = string;
        var regex = /(\d)/g;
        var matches = val.match(regex);
        if (val.length > num1 && val.length <= num2) {
            matches.splice(num1, 0, "-");
        }
        if (val.length > num2) {
            matches.splice(num1, 0, "-");
            matches.splice(num2 + 1, 0, "-");
        }
        var val = matches.join("");
        return val;
    }

    static ssnFormat(value) {
        return FormatHelper.addDashes(value, 2, 4).substr(0, 10);
    }

    static phoneNumberFormat(value) {
        let regex = /(\d)/g;
        if (value.match(regex)) {
            if (!value.startsWith("1")) {
                value = value.replace(/\s+g/, "");
                return FormatHelper.addDashes(value, 3, 6).substr(0, 12);
            } else {
                return FormatHelper.formatWithOne(value);
            }
        }
        return "";
    }

    static formatWithOne(value) {
        value = value.substr(0, 14);
        value = value.replace(/\s+g/, "");
        value = value.replace(/-/g, "");
        let regex = /(\d)/g;
        let val = value;
        if (value.length == 11) {
            let matches = val.match(regex);
            matches.splice(1, 0, "-");
            matches.splice(5, 0, "-");
            matches.splice(9, 0, "-");
            val = matches.join("");
            return val;
        } else {
            return FormatHelper.addDashes(value, 3, 6).substr(0, 12);
        }
    }

    static noNumbers(string) {
        return string.replace(/[0-9]/g, "");
    }

    static vinFormat(value) {
        return value.substr(0, 17);
    }

    static isValidEmail(email) {
        let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    static isValidPhoneNumber(phoneNumber) {
        if (phoneNumber.length == 12) {
            let regex = /^[2-9]{1}[0-9]{2}[-][2-9]{1}[0-9]{2}[-][0-9]{4}$/;
            return regex.test(phoneNumber);
        }
        let regex = /^\d{1}-\d{3}-\d{3}-\d{4}$|^\d{3}-\d{3}-\d{4}$/;
        return regex.test(phoneNumber);
    }

    static isValidZipCode(zipCode) {
        let regex = /^\d{5}(-\d{4})?$/;
        return regex.test(zipCode);
    }
}
